import { CommonModule } from '@angular/common'
import { NgModule } from '@angular/core'

import { MatcherPipe } from './matcher.pipe'
import { PopoverDirective } from './popover.directive'
import { PreventAlphaDirective } from './prevent-alpha.directive'


@NgModule({
	declarations: [PreventAlphaDirective, PopoverDirective, MatcherPipe],
	imports: [CommonModule],
	exports: [PreventAlphaDirective, PopoverDirective, MatcherPipe],
})
export class SharedModule { }
